import { capitalize } from '@/Shared/helper.js'
import { useCheckedBrandsStore } from '@/store/checkedBrands'
import { useCheckedShopsStore } from '@/store/checkedShops'
import { useFavoriteBrandsStore } from '@/store/favoriteBrands'
import { useFavoriteShopsStore } from '@/store/favoriteShops'

/**
 * チェックボックスの状態を管理
 * @param {{
 * checkbox: reactive,
 * category: String,
 * slug: String,
 * }}
 * 以下の引数をオブジェクトに格納
 * @param checkbox この関数を使用するファイルからその状態を渡すためのreactiveオブジェクト    
 * 使用例：    
 * updateIcon使用時：const checkbox = reactive({active: false})    
 * updateCheckedList使用時：const checkbox = reactive({checkedList: []})
 * @param category カテゴリー
 * @param slug スラグ
 */

export default function useCheckbox({checkbox, category, slug}){

  const stores = {
    'favoriteBrands' : useFavoriteBrandsStore(),
    'favoriteShops' : useFavoriteShopsStore(),
    'checkedBrands' : useCheckedBrandsStore(),
    'checkedShops' : useCheckedShopsStore(),
  }

  const favoriteStore = stores[`favorite${capitalize(category)}s`]
  const checkedStore = stores[`checked${capitalize(category)}s`]

  /**
   * アイコンの状態の切り替え
   * @function
   */
  const updateIcon = () => {
    const checkedList = checkedStore.getList
    checkbox.active = checkedList.includes(slug)
  }

  /**
   * チェックボックスのクリックで、リストを更新
   * @function
   * @param {MouseEvent} e マウスイベント
   */
  const updateCheckedList = (e) => {
    const target = e.target.closest('.btn-toggle-check')
    if(!target) return
    const slug = target.getAttribute('slug')

    // お気に入りで、リストを更新
    if(isFavorite(slug) && !isChecked(slug)){
      checkedStore.updateList(favoriteStore.getList)
      checkedStore.addItem(slug)
      checkbox.checkedList = checkedStore.getList 
      return
    }

    if(isChecked(slug)){
      checkedStore.removeItem(slug)
    }else{
      checkedStore.addItem(slug)
    }
    checkedStore.removeItem('favorite')

    checkbox.checkedList = checkedStore.getList
  }

  const isChecked = slug => checkedStore.getList.includes(slug)
  const isFavorite = slug => slug === 'favorite'

  /**
   * サブスクライブ用（checkedStoreのstateに変更があった際にcallbackを実行）
   * @function
   * @param {Function} callback コールバック関数
   */
  const subscribeCheckedList = (callback) => {
    checkedStore.$subscribe(() => {
      callback()
    })
  }

  return {updateIcon, updateCheckedList, subscribeCheckedList}
}